import { useWidgetLanguage } from '@/hooks'
import { OtherAvailabilityTitleRow } from '@/Reservations/Search/OtherAvailability'
import type { ReservationWidget as ReservationWidgetModel } from '@sevenrooms/domain'

interface VenueInfoRowProps {
  venueInfo: ReservationWidgetModel.VenueInfo['venues'][0]
  onTitleClick: (venueUrlKey: string) => void
}

export function VenueInfoRow({ venueInfo, onTitleClick }: VenueInfoRowProps) {
  const { selectedLanguage } = useWidgetLanguage()

  const venueShortDescription =
    venueInfo.languageStrings[selectedLanguage]?.resWidgetCrossSellVenueShortDescription ||
    venueInfo.languageStrings.en?.resWidgetCrossSellVenueShortDescription

  return (
    <OtherAvailabilityTitleRow
      title={venueInfo.venueName}
      subtitle={venueShortDescription}
      titleDataTest={`other-venue-availability-title-${venueInfo.urlKey}`}
      subtitleDataTest={`other-venue-availability-subtitle-${venueInfo.urlKey}`}
      onTitleClick={() => onTitleClick(venueInfo.urlKey)}
    />
  )
}
